import { createFileRoute, Outlet, retainSearchParams } from "@tanstack/react-router";
import { Shell } from "../app/shell/shell";

/** The environment chosen in the top bar, kept on every app link (`retainSearchParams`). */
export interface AppSearch {
  env?: string;
}

/** Every app route sits under this layout: no identity means a sign-in first. */
export const Route = createFileRoute("/_app")({
  validateSearch: (search: Record<string, unknown>): AppSearch =>
    typeof search.env === "string" && search.env ? { env: search.env } : {},
  search: { middlewares: [retainSearchParams(["env"])] },
  beforeLoad: async ({ context, location }) => {
    const identity = await context.auth.current();
    if (identity) return { identity };
    await context.auth.signIn(location.href);
    // The browser is leaving for the sign-in page: never resolve, so nothing renders meanwhile.
    return new Promise<never>(() => {});
  },
  component: AppLayout,
});

function AppLayout() {
  return (
    <Shell>
      <Outlet />
    </Shell>
  );
}
